import React from 'react';

import { TEXT_USER_LIST } from 'constants/string/texts';

const OverviewItemsFacility = ({ options }) => {
  const handleItemOverview = () => {
    const from = (options.page - 1) * options.page_size + 1;
    const to = from + options.page_size - 1;
    const total = options.total;

    return `${from} - ${to > total ? total : to} / ${total} ${TEXT_USER_LIST.PART}`;
  };

  return (
    <>
      <div className="flex items-end justify-between gap-2 mt-2">
        <p className="text-sm opacity-85 text-gray-336">{handleItemOverview()}</p>
      </div>
    </>
  );
};

export default React.memo(OverviewItemsFacility);
